import { HEADER_CSRF } from "@charter/shared";
import { API_URL } from "@/config/env";
import { crash } from "@/platform/crash";
import { track } from "./telemetry";

let sent = 0;

/** Ships an error to the game server's log (POST /v1/client-errors). Capped per page load. */
function report(message: string, stack?: string): void {
  if (sent++ > 20) return;
  const body = JSON.stringify({
    message: message.slice(0, 500),
    stack: stack?.slice(0, 4000),
    url: window.location.href,
  });
  void fetch(`${API_URL}/v1/client-errors`, {
    method: "POST",
    // the server refuses mutating requests without it (CSRF check, docs/paywall.md)
    headers: { "content-type": "application/json", [HEADER_CSRF]: "1" },
    body,
    keepalive: true,
  }).catch(() => undefined);
}

/**
 * Route uncaught errors into telemetry, the crash slot, and the server's structured log so a
 * playtest bug report can be matched to a stack trace without reproducing it.
 */
export function installErrorReporting(): void {
  window.addEventListener("error", (event) => {
    track("error.uncaught", { message: String(event.message), source: event.filename ?? "" });
    crash.get().captureException(event.error ?? event.message, { source: event.filename ?? "" });
    report(String(event.message), event.error instanceof Error ? event.error.stack : undefined);
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason instanceof Error ? event.reason.message : String(event.reason);
    track("error.unhandled_rejection", { message: reason });
    crash.get().captureException(event.reason, { kind: "unhandled_rejection" });
    report(reason, event.reason instanceof Error ? event.reason.stack : undefined);
  });
}
